import { render, staticRenderFns } from "./ListagemEnviosEmbrapa.vue?vue&type=template&id=3f811ac4&scoped=true"
import script from "./ListagemEnviosEmbrapa.vue?vue&type=script&lang=js"
export * from "./ListagemEnviosEmbrapa.vue?vue&type=script&lang=js"
import style0 from "./ListagemEnviosEmbrapa.vue?vue&type=style&index=0&id=3f811ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f811ac4",
  null
  
)

export default component.exports